import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { isDefined } from "@omni/utils/helper.utils";

export const extractAccessoires = (product?: Product<ProductFieldSet.Full>) => {
    const accessories = product?.references?.accessories;
    if (!accessories) return [];

    return accessories.filter(isDefined);
};
